export const DataType = {
  STRING: 'String',
  ANCHOR: 'Anchor',
  SELECT: 'Select'
}

